import { usePlayer } from './player.model'
import type { IPlayerProps } from './player.types'
import { PlayerView } from './player.view'

const PlayerContent = (props: IPlayerProps) => {
  const model = usePlayer({ url: props.url })

  return <PlayerView {...props} {...model} />
}

/**
 * Resets internal play/error state whenever the URL changes by remounting via
 * `key` (replaces the legacy `componentDidUpdate` reset — no effect needed).
 */
export const Player = (props: IPlayerProps) => <PlayerContent key={props.url} {...props} />
